// ネット予約3.0 へのリダイレクト先。
// 店舗の Web予約バージョン（toreta-rails）が v3 のとき、予約フォームの入口からここへ遷移させる。

// 本番の予約フォームのホスト。これ以外（staging / ローカル）は ネット予約3.0 の staging へ飛ばす
const PRODUCTION_HOST = "reserve.toretaasia.com";

// ネット予約3.0 の店舗サブドメインの親ドメイン（https://{public_key}.{domain}/）
const V3_DOMAIN_PRODUCTION = "toreta.at";
const V3_DOMAIN_STAGING = "yoyaku-stg.toreta.in";

export const webReservationV3Url = (publicKey: string): string => {
    const domain = window.location.hostname === PRODUCTION_HOST ? V3_DOMAIN_PRODUCTION : V3_DOMAIN_STAGING;
    // 実クエリ（utm 等）は引き継ぐ。HashRouter 側（#/?stamp=...）は ネット予約3.0 では使わないので渡さない
    return `https://${publicKey}.${domain}/${window.location.search}`;
};
